import { render, staticRenderFns } from "./m_plogskill.vue?vue&type=template&id=67d0b601&scoped=true&"
import script from "./m_plogskill.vue?vue&type=script&lang=js&"
export * from "./m_plogskill.vue?vue&type=script&lang=js&"
import style0 from "./m_plogskill.vue?vue&type=style&index=0&id=67d0b601&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0b601",
  null
  
)

export default component.exports